<div class="integrations-component">
    <div class="filter-container">
        <ws-searchbar [config]="integrationSearchConfig" [searchFunction]="searchIntegrations"
            [resultMapper]="mapIntegrationForDisplay" (submit)="onSearchSubmit($event)"
            (searchTextChanged)="onSearchTextChanged($event)"
            (resultSelected)="onIntegrationSelected($event)">
        </ws-searchbar>

        <ws-selector [formControl]="statusControl" [options]="statusControlViews" [fixedText]="'All' | translate"
            (selectedItemsChange)="optionsStatusChanged($event)">
        </ws-selector>

        <ws-selector [formControl]="categoriesControl" [options]="categoriesViews" [multiSelect]="true" multiple
            [fixedText]="'Category' | translate" (selectedItemsChange)="optionsCategories($event)">
        </ws-selector>
    </div>

    <div *ngFor="let category of filteredCategories" class="category-container">
        <p class="category-title">{{ ('integrationTypes.' + category) | translate }}</p>
        <div class="flex">
            <div *ngFor="let integration of filteredIntegrations(category)" class="integration-card">
                <div class="integration-card-header">
                    <img [src]="integration.integration.imageUrl" alt="" class="integration-card-logo">
                    <div class="integration-card-badge">
                        <ws-chip *ngIf="isStripeIntegration(integration.integration)"
                            label="superadmin only"
                            [type]="WsChipType.SECONDARY"></ws-chip>
                        <ws-chip *ngIf="!!!!getBadgeText(integration.integration, integration)"
                            [backgroundColor]="getBadgeColor(integration.integration, integration)"
                            [label]="getBadgeText(integration.integration, integration)" color="white"></ws-chip>
                    </div>
                </div>
                <div class="integration-card-title">
                    {{ getIntegrationDisplayName(integration.integration) }}
                </div>

                <div class="integration-card-description"
                    [innerHTML]="getIntegrationDescriptionHtml(integration.integration)">
                </div>
                <div class="integration-card-actions"
                    *let="isInstalledInThisWinery(integration.integration) as isInstalled">
                    <div style="display: flex; gap: 10px;">
                        <mat-slide-toggle (change)="toggleActiveState(integration.integration, $event.checked)"
                            *ngIf="isInstalled && !isWhatsAppIntegration(integration.integration, integration)"
                            [checked]="isEnabledInThisWinery(integration.integration)"></mat-slide-toggle>
                        <mat-icon
                            *ngIf="isInstalled && !isWhatsAppIntegration(integration.integration, integration) && isEnabledInThisWinery(integration.integration) && !isConnected(integration.integration)"
                            [wsTooltip]="'A technical error occurred, please contact support' | translate"
                            style="color: #eb4646;">error
                        </mat-icon>
                    </div>
                    <div class="integration-card-button">
                        <ws-button (click)="goToIntegration(integration.integration.id)"
                            *ngIf="isConnected(integration.integration) || integration.integration.active"
                            [disabled]="isDetailsButtonDisabled(integration.integration)"
                            [tooltip]="getDetailsButtonTooltip(integration.integration)">
                            <mat-icon style="color: #b3b3b3;">arrow_forward_ios</mat-icon>
                        </ws-button>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div *ngIf="!filteredCategories?.length" class="category-container" style="text-align: center;">
        <p class="category-title">{{ 'No integration to show' | translate }}</p>
    </div>

</div>